// extracted by mini-css-extract-plugin
module.exports = {"fileList":"Details_fileList__3ffzZ","dialog":"Details_dialog__1vwPZ"};